import { render } from "./AppChoose.vue?vue&type=template&id=50494271&scoped=true"
import script from "./AppChoose.vue?vue&type=script&lang=js"
export * from "./AppChoose.vue?vue&type=script&lang=js"

import "./AppChoose.vue?vue&type=style&index=0&id=50494271&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50494271"]])

export default __exports__